import React from 'react'
import RestaurantMenuPopupContainer from './container'
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { removePOSData } from "pages/login/services";
import { useDispatch } from "react-redux";


const RestaurantMenuPopup = ({
    anchorEl,
    open,
    onClose,
    restaurantName = "Burger Point",
    restaurantDescription = "Fast-food Restaurant",
    logoSrc,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [manageMenuOpen, setManageMenuOpen] = useState(false);
    const [orderRelatedOpen, setOrderRelatedOpen] = useState(false);
    const [openLogoutConfirm, setOpenLogoutConfirm] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    useEffect(() => {
        if (!open) {
            setManageMenuOpen(false);
            setOrderRelatedOpen(false);
        }
    }, [open]);

    const handleLogoutClick = () => {
        onClose();
        setOpenLogoutConfirm(true);
    };
    const handleCloseConfirm = () => {
        if (!isLoggingOut) {
            setOpenLogoutConfirm(false);
        }
    };
    const handleConfirmLogout = async () => {
        setIsLoggingOut(true);

        try {
            dispatch(removePOSData());

            // Redirect to login
            navigate("/login", { replace: true });
        } catch (err) {
            console.error("Logout failed", err);
            setIsLoggingOut(false);
        }
    };
    
    const handleManageMenuClick = () => {
        // If manage menu is currently closed and order related is open, close order related first
        if (!manageMenuOpen && orderRelatedOpen) {
            setOrderRelatedOpen(false);
        }
        // Toggle manage menu
        setManageMenuOpen(!manageMenuOpen);
    };

    const handleOrderRelatedClick = () => {
        // If order related is currently closed and manage menu is open, close manage menu first
        if (!orderRelatedOpen && manageMenuOpen) {
            setManageMenuOpen(false);
        }
        // Toggle order related
        setOrderRelatedOpen(!orderRelatedOpen);
    };

    const handleClickItem = (item) => {
        navigate(`/${item}`)
    }


    return (
        <RestaurantMenuPopupContainer
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            restaurantName={restaurantName}
            restaurantDescription={restaurantDescription}
            logoSrc={logoSrc}
            handleOrderRelatedClick={handleOrderRelatedClick}
            handleManageMenuClick={handleManageMenuClick}
            handleConfirmLogout={handleConfirmLogout}
            handleCloseConfirm={handleCloseConfirm}
            handleLogoutClick={handleLogoutClick}
            manageMenuOpen={manageMenuOpen}
            openLogoutConfirm={openLogoutConfirm}
            orderRelatedOpen={orderRelatedOpen}
            isLoggingOut={isLoggingOut}
            handleClickItem={handleClickItem}
        />
    )
}

export default RestaurantMenuPopup




